/* ==========================================================================
   Edstrøms product page — shared JavaScript
   One small state engine (window.EDS) drives the configurator and every
   section that shows a price (sticky bar, final CTA, pricing tiers, ROI,
   specs, plate demo). Sections talk through data-attributes only, so any
   section can be removed in the theme editor without breaking the others.
   ========================================================================== */
(function () {
  if (window.EDS) return; // loaded once even if several sections include the script

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };
  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn); };

  var EDS = window.EDS = {
    config: null,
    state: { watt: 0, kuffert: 0, stand: 0, qty: 1, img: 0 },
    values: {},
    locale: 'da-DK',
    suffix: ',-',
    kr: function (n) { return Math.round(n).toLocaleString(EDS.locale) + EDS.suffix; },
    num: function (n) { return Math.round(n).toLocaleString(EDS.locale); },
    set: function (patch) { for (var k in patch) EDS.state[k] = patch[k]; EDS.render(); },
    render: function () {}
  };

  /* --------------------------------------------------------------------
     Configurator
     -------------------------------------------------------------------- */
  var cfgRoot = $('[data-eds-configurator]');
  if (cfgRoot) {
    try { EDS.config = JSON.parse($('[data-eds-config]', cfgRoot).textContent); } catch (e) { console.error('EDS config', e); }
  }
  var C = EDS.config;
  if (C) {
    EDS.locale = C.locale || EDS.locale;
    EDS.suffix = (C.priceSuffix != null) ? C.priceSuffix : EDS.suffix;
    EDS.state.watt = C.defaults.watt || 0;
    EDS.state.kuffert = C.defaults.kuffert || 0;
    EDS.state.stand = C.defaults.stand || 0;
    EDS.state.qty = C.defaults.qty || 1;
  }

  function tok(s, v) {
    return String(s == null ? '' : s).replace(/\[(\w+)\]/g, function (m, k) { return (v[k] != null) ? v[k] : m; });
  }

  function compute() {
    if (!C) return null;
    var st = EDS.state, W = C.watts, CS = C.cases, SD = C.stands, T = C.tiers;
    if (!W.length) return null;
    var wt = Object.assign({}, W[st.watt] || W[0]);
    var cs = Object.assign({ name: '', price: 0 }, CS[st.kuffert] || {});
    var sd = Object.assign({ name: '', price: 0 }, SD[st.stand] || {});
    var wattPrices = null, casePrices = null, standPrices = null, selVariant = null;
    if (C.variants && C.variants.length) {
      // prices come from the product's variant matrix (Effekt × Kuffert × Stander)
      var P = C.optPos, c0 = CS[0] ? CS[0].value : null, s0 = SD[0] ? SD[0].value : null;
      var find = function (w, c, s) {
        for (var i = 0; i < C.variants.length; i++) {
          var o = C.variants[i].opts;
          if (o[P.watt] !== w) continue;
          if (P.case > -1 && c != null && o[P.case] !== c) continue;
          if (P.stand > -1 && s != null && o[P.stand] !== s) continue;
          return C.variants[i];
        }
        return null;
      };
      var price = function (w, c, s) { var v = find(w, c, s); return v ? v.price : 0; };
      var wv = wt.value, cv = cs.value || null, sv = sd.value || null;
      wt.price = price(wv, c0, s0);
      cs.price = cv ? price(wv, cv, s0) - price(wv, c0, s0) : 0;
      sd.price = sv ? price(wv, cv, sv) - price(wv, cv, s0) : 0;
      wattPrices = W.map(function (x) { return price(x.value, cv, s0); });
      casePrices = CS.map(function (x) { return price(wv, x.value, s0) - price(wv, c0, s0); });
      standPrices = SD.map(function (x) { return price(wv, cv, x.value) - price(wv, cv, s0); });
      selVariant = find(wv, cv, sv);
    }
    var unit = wt.price + cs.price;

    var tiers = T.map(function (t) {
      var total = Math.round(unit * t.qty * (1 - t.discount / 100));
      var per = Math.round(total / t.qty);
      return {
        qty: t.qty, discount: t.discount, total: total, per: per,
        was: t.qty > 1 ? unit * t.qty : null,
        saving: Math.round(unit * t.discount / 100),
        savingTotal: unit * t.qty - total
      };
    });
    var active = null;
    for (var i = 0; i < tiers.length; i++) if (tiers[i].qty === st.qty) active = tiers[i];
    if (!active) { active = tiers[0]; st.qty = active.qty; }
    var grand = active.total + sd.price;
    var kr = EDS.kr;

    var otherWatts = W.filter(function (x) { return x.w !== wt.w; }).map(function (x) { return x.w + ' W'; }).join(' og ');

    var v = {
      watt: wt.w, wattName: wt.w + 'W', wattLabel: wt.w + ' W:', wattFit: wt.fit || '',
      model: wt.model || '', speed: wt.speed || '', depth: wt.depth || '', otherWatts: otherWatts,
      case: cs.name, stand: sd.name, standPrice: sd.price ? '+ ' + kr(sd.price) : '—',
      qty: st.qty, unit: kr(unit), unitRaw: unit, lineTotal: kr(unit * st.qty), caseSuffix: cs.price ? ', ' + (C.labels.withCase || 'med kuffert') : '',
      total: kr(grand), totalRaw: grand,
      perMachine: kr(Math.round(active.total / active.qty)),
      lease: kr(Math.round(grand / (C.leaseMonths || 36) / 5) * 5),
      pct: active.discount, saving: kr(active.saving), savingTotal: kr(active.savingTotal),
      qtyLabel: active.qty + ' ' + (active.qty === 1 ? (C.labels.machine || 'maskine') : (C.labels.machines || 'maskiner')),
      unitLine: active.qty === 1 ? kr(unit) + ' ' + (C.labels.perMachine || 'pr. maskine')
        : kr(Math.round(active.total / active.qty)) + ' ' + (C.labels.perMachine || 'pr. maskine') + ' — ' + (C.labels.normally || 'normalt') + ' ' + kr(unit),
      stickyQty: (active.qty + ' ' + (C.labels.pcs || 'stk.')) + (cs.price ? ' · ' + (C.labels.caseShort || 'kuffert') : '') + (sd.price ? ' · ' + (C.labels.standShort || 'stander') : ''),
      stickySub: active.qty === 1 ? (C.labels.stickySubSingle || '') : tok(C.labels.stickySubMulti || '', { savingTotal: kr(active.savingTotal) }),
      tierNote: tok(C.labels.tierNote || '', { watt: wt.w, caseSuffix: cs.price ? ' ' + (C.labels.withCase || 'med kuffert') : '' }),
      tiers: tiers, active: active, unitNum: unit, grandNum: grand, wt: wt, cs: cs, sd: sd,
      wattPrices: wattPrices, casePrices: casePrices, standPrices: standPrices, selVariant: selVariant
    };
    // per-tier convenience tokens for sections outside the configurator
    tiers.forEach(function (t, i) {
      v['tier' + (i + 1) + 'Price'] = kr(t.per);
      v['tier' + (i + 1) + 'Was'] = t.was ? kr(unit) : '';
      v['tier' + (i + 1) + 'Saving'] = kr(t.saving);
      v['tier' + (i + 1) + 'Total'] = kr(t.total);
    });
    return v;
  }

  function tierTokens(v, i) {
    var t = v.tiers[i]; if (!t) return {};
    return { saving: EDS.kr(t.saving), savingTotal: EDS.kr(t.savingTotal), tierPrice: EDS.kr(t.per), tierWas: t.was ? EDS.kr(v.unitNum) : '', tierTotal: EDS.kr(t.total), pct: t.discount, tierQty: t.qty };
  }

  EDS.render = function () {
    var v = compute();
    if (!v) return;
    EDS.values = v;
    var st = EDS.state;

    // selection states
    $$('[data-eds-pick]').forEach(function (el) {
      var kind = el.getAttribute('data-eds-pick');
      var idx = parseInt(el.getAttribute('data-index'), 10);
      var sel = kind === 'tier' ? parseInt(el.getAttribute('data-qty'), 10) === st.qty : st[kind] === idx;
      el.classList.toggle('is-selected', sel);
      el.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    // watt card prices include the chosen case
    $$('[data-eds-watt-price]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-eds-watt-price'), 10);
      if (v.wattPrices) el.textContent = EDS.kr(v.wattPrices[i]);
      else if (C.watts[i]) el.textContent = EDS.kr(C.watts[i].price + v.cs.price);
    });
    $$('[data-eds-case-price]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-eds-case-price'), 10), p = v.casePrices ? v.casePrices[i] : (C.cases[i] || {}).price;
      el.textContent = p > 0 ? '+ ' + EDS.kr(p) : (C.labels.included || 'Inkluderet');
    });
    $$('[data-eds-stand-price]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-eds-stand-price'), 10), p = v.standPrices ? v.standPrices[i] : (C.stands[i] || {}).price;
      el.textContent = p > 0 ? '+ ' + EDS.kr(p) : '\u2014';
    });
    // simple text bindings
    $$('[data-eds-text]').forEach(function (el) {
      var k = el.getAttribute('data-eds-text');
      if (v[k] != null && typeof v[k] !== 'object') el.textContent = v[k];
    });
    // template bindings with [tokens]; tier-scoped where relevant
    $$('[data-eds-tpl]').forEach(function (el) {
      var scope = el.closest('[data-eds-tier-scope]');
      var extra = scope ? tierTokens(v, parseInt(scope.getAttribute('data-eds-tier-scope'), 10)) : {};
      var merged = Object.assign({}, v, extra);
      el.textContent = tok(el.getAttribute('data-eds-tpl'), merged);
    });
    // conditional visibility
    $$('[data-eds-if]').forEach(function (el) {
      var cond = el.getAttribute('data-eds-if'), show = true;
      if (cond === 'qtyGt1') show = st.qty > 1;
      else if (cond === 'hasStand') show = !!v.sd.price;
      else if (cond === 'hasCase') show = !!v.cs.price;
      else if (cond.indexOf('qty=') === 0) show = st.qty === parseInt(cond.slice(4), 10);
      else if (cond.indexOf('tierWas') === 0) { var ti = parseInt(cond.slice(7), 10); show = !!(v.tiers[ti] && v.tiers[ti].was); }
      el.classList.toggle('eds-hidden', !show);
    });
    // "best" tier card highlight follows the highest discount
    var best = 0; v.tiers.forEach(function (t, i) { if (t.discount > v.tiers[best].discount) best = i; });
    $$('[data-eds-tier-card]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-eds-tier-card'), 10);
      if (el.getAttribute('data-best') === 'auto') el.classList.toggle('is-best', i === best);
    });
    // main image everywhere (hero + sticky bar)
    var src = C.images[st.img] || C.images[0];
    $$('[data-eds-img="main"]').forEach(function (img) { if (src && img.getAttribute('src') !== src) img.src = src; });
    $$('[data-eds-thumb]').forEach(function (el) { el.classList.toggle('is-active', parseInt(el.getAttribute('data-index'), 10) === st.img); });
    $$('[data-eds-dot]').forEach(function (el) { el.classList.toggle('is-active', parseInt(el.getAttribute('data-index'), 10) === st.img); });

    doc.dispatchEvent(new CustomEvent('eds:update', { detail: v }));
  };

  /* click handling for options, gallery, tier cards */
  on(doc, 'click', function (e) {
    var t = e.target;
    var pick = t.closest('[data-eds-pick]');
    if (pick && C) {
      var kind = pick.getAttribute('data-eds-pick');
      if (kind === 'tier') EDS.set({ qty: parseInt(pick.getAttribute('data-qty'), 10) });
      else { var p = {}; p[kind] = parseInt(pick.getAttribute('data-index'), 10); EDS.set(p); }
      if (pick.hasAttribute('data-scroll')) { var tgt = $(pick.getAttribute('data-scroll')); tgt && tgt.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    var thumb = t.closest('[data-eds-thumb],[data-eds-dot]');
    if (thumb && C) { EDS.set({ img: parseInt(thumb.getAttribute('data-index'), 10) }); return; }
    if (t.closest('[data-eds-prev]') && C) { EDS.set({ img: (EDS.state.img + C.images.length - 1) % C.images.length }); return; }
    if (t.closest('[data-eds-next]') && C) { EDS.set({ img: (EDS.state.img + 1) % C.images.length }); return; }
    var play = t.closest('[data-eds-play]');
    if (play && C) {
      var url = play.getAttribute('data-url');
      if (url) window.open(url, '_blank', 'noopener'); else EDS.set({ img: Math.min(1, C.images.length - 1) });
      return;
    }
  });

  /* Add to cart — posts the chosen variants to /cart/add.js, falls back to a link */
  on(doc, 'click', function (e) {
    var btn = e.target.closest('[data-eds-add]');
    if (!btn || !C) return;
    var v = EDS.values, st = EDS.state, items = [];
    if (v.selVariant) items.push({ id: v.selVariant.id, quantity: st.qty });
    else if (v.wt && v.wt.variant) items.push({ id: v.wt.variant, quantity: st.qty });
    if (!v.selVariant && v.cs && v.cs.variant && v.cs.price) items.push({ id: v.cs.variant, quantity: st.qty });
    if (!v.selVariant && v.sd && v.sd.variant && v.sd.price) items.push({ id: v.sd.variant, quantity: 1 });
    if (!items.length) {
      // no variant IDs configured → behave like a normal link (e.g. to #kob or a contact page)
      if (btn.tagName !== 'A') window.location.href = C.fallbackUrl || '#kob';
      return;
    }
    e.preventDefault();
    btn.setAttribute('disabled', 'disabled');
    var props = {};
    props[C.labels.propWatt || 'Effekt'] = v.watt + ' W';
    if (v.cs.name) props[C.labels.propCase || 'Transport'] = v.cs.name;
    if (v.sd.price) props[C.labels.propStand || 'Stander'] = v.sd.name;
    if (!v.selVariant) items[0].properties = props;
    fetch(C.cartAddUrl || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status && res.status >= 400) throw new Error(res.description || res.message || 'Cart error');
      window.location.href = C.cartUrl || '/cart';
    }).catch(function (err) {
      console.error(err); alert(err.message || 'Kunne ikke lægge i kurv'); btn.removeAttribute('disabled');
    });
  });

  /* Countdown (end date from settings, else first day of next month) */
  $$('[data-eds-countdown]').forEach(function (box) {
    var endAttr = box.getAttribute('data-end');
    var end = endAttr ? new Date(endAttr) : null;
    if (!end || isNaN(end.getTime())) { end = new Date(); end.setMonth(end.getMonth() + 1); end.setDate(1); end.setHours(0, 0, 0, 0); }
    var p = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var d = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var out = { days: Math.floor(d / 86400), hours: Math.floor(d % 86400 / 3600), min: Math.floor(d % 3600 / 60), sec: d % 60 };
      for (var k in out) { var el = $('[data-cd="' + k + '"]', box); if (el) el.textContent = p(out[k]); }
    }
    tick(); setInterval(tick, 1000);
  });

  /* --------------------------------------------------------------------
     ROI calculator (works with or without the configurator)
     -------------------------------------------------------------------- */
  $$('[data-eds-roi]').forEach(function (root) {
    var range = $('input[type=range]', root);
    var outsource = parseFloat(root.getAttribute('data-outsource')) || 340;
    var own = parseFloat(root.getAttribute('data-own')) || 90;
    var hoursPer = parseFloat(root.getAttribute('data-hours')) || 0.3;
    var basePrice = parseFloat(root.getAttribute('data-price')) || 29995;
    function calc() {
      var per = Number(range.value);
      var unit = (EDS.values && EDS.values.unitNum) || basePrice;
      var wattTxt = (EDS.values && EDS.values.watt) ? EDS.values.watt + ' W' : root.getAttribute('data-watt') || '';
      var savedMonth = Math.round(per * (outsource - own));
      var payback = Math.max(0.5, Math.round((unit / savedMonth) * 10) / 10);
      var set = function (k, val) { $$('[data-roi="' + k + '"]', root).forEach(function (el) { el.textContent = val; }); };
      set('perWeek', per);
      set('savedMonth', EDS.num(savedMonth));
      set('savedYear', EDS.num(savedMonth * 12));
      set('payback', String(payback).replace('.', ','));
      set('hoursSaved', Math.round(per * 12 * hoursPer));
      set('unit', EDS.kr(unit));
      set('watt', wattTxt);
      var bar = $('[data-roi="bar"]', root);
      if (bar) bar.style.width = Math.max(4, Math.min(100, Math.round((12 - Math.min(12, payback)) / 12 * 100))) + '%';
    }
    on(range, 'input', calc);
    on(doc, 'eds:update', calc);
    calc();
    var tg = $('[data-roi-toggle]', root), tx = $('[data-roi-assume]', root);
    on(tg, 'click', function () { tg.classList.toggle('is-open'); tx && tx.classList.toggle('is-open'); });
  });

  /* --------------------------------------------------------------------
     Small interactive bits
     -------------------------------------------------------------------- */
  // Header burger
  $$('[data-eds-header]').forEach(function (h) {
    on($('[data-eds-burger]', h), 'click', function () { h.classList.toggle('is-open'); });
    $$('.eds-mobile-menu a', h).forEach(function (a) { on(a, 'click', function () { h.classList.remove('is-open'); }); });
  });

  // FAQ accordion
  on(doc, 'click', function (e) {
    var q = e.target.closest('[data-eds-faq-q]'); if (!q) return;
    var item = q.closest('.eds-faq__item'), list = item.parentNode, wasOpen = item.classList.contains('is-open');
    $$('.eds-faq__item', list).forEach(function (i) { i.classList.remove('is-open'); });
    if (!wasOpen) item.classList.add('is-open');
  });

  // Use-case tabs
  $$('[data-eds-usecases]').forEach(function (root) {
    var img = $('[data-uc-img]', root), label = $('[data-uc-label]', root), cap = $('[data-uc-caption]', root);
    $$('[data-eds-usecase]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        $$('[data-eds-usecase]', root).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (img && btn.getAttribute('data-img')) img.src = btn.getAttribute('data-img');
        if (label) label.textContent = btn.getAttribute('data-label') || '';
        if (cap) cap.textContent = btn.getAttribute('data-caption') || '';
      });
    });
  });

  // Plate demo
  $$('[data-eds-plate]').forEach(function (root) {
    var input = $('[data-plate-input]', root), text = $('[data-plate-text]', root), board = $('[data-plate-board]', root), note = $('[data-plate-note]', root);
    var placeholder = input ? input.getAttribute('placeholder') : '';
    on(input, 'input', function () { text.textContent = (input.value || placeholder).toUpperCase(); });
    $$('[data-plate-mat]', root).forEach(function (b) {
      on(b, 'click', function () {
        $$('[data-plate-mat]', root).forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        board.setAttribute('data-mat', b.getAttribute('data-plate-mat'));
        if (note) note.textContent = b.getAttribute('data-note') || '';
      });
    });
  });

  // Chat widget
  $$('[data-eds-chat]').forEach(function (root) {
    var fab = $('[data-chat-toggle]', root), icon = $('[data-chat-icon]', root), letter = icon ? icon.textContent : 'K';
    on(fab, 'click', function () {
      root.classList.toggle('is-open');
      if (icon) icon.textContent = root.classList.contains('is-open') ? '×' : letter;
    });
  });

  // Smooth scroll for in-page anchors inside our sections
  on(doc, 'click', function (e) {
    var a = e.target.closest('.eds a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1); if (!id) return;
    var tgt = doc.getElementById(id); if (!tgt) return;
    e.preventDefault(); tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Format raw numbers rendered by Liquid (Liquid has no thousands separator); the configurator overrides the dynamic ones afterwards
  $$('[data-eds-fmt]').forEach(function (el) { el.textContent = EDS.kr(parseFloat(el.getAttribute('data-eds-fmt'))); });

  EDS.render();

  // Theme editor: re-render when a section is reloaded
  on(doc, 'shopify:section:load', function () { EDS.render(); });
})();










/* ============================================================
   Edstrøms · Video player for [data-eds-play] thumbnails
   Paste at the bottom of eds.js
   ============================================================ */
(function () {
  'use strict';

  function toEmbedUrl(type, id) {
    if (!id) return null;
    if (type === 'youtube') {
      return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
    }
    return null;
  }

  function detectTypeFromUrl(url) {
    if (!url) return null;
    var m;
    if ((m = url.match(/youtu\.be\/([\w-]+)/)))            return { type: 'youtube', id: m[1] };
    if ((m = url.match(/youtube\.com.*[?&]v=([\w-]+)/)))   return { type: 'youtube', id: m[1] };
    if ((m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)))  return { type: 'vimeo',   id: m[1] };
    if (/\.(mp4|webm|ogv|ogg|mov|m3u8)(\?|#|$)/i.test(url))return { type: 'file',    url: url };
    return { type: 'iframe', url: url };
  }

  function buildPlayer(thumb) {
    var type    = thumb.getAttribute('data-video-type') || '';
    var sources = thumb.getAttribute('data-video-sources') || '';
    var id      = thumb.getAttribute('data-video-id') || '';
    var url     = thumb.getAttribute('data-url') || '';

    /* Fallback thumb has no data-video-type — detect from data-url */
    if (!type && url) {
      var d = detectTypeFromUrl(url);
      if (d) {
        type = d.type;
        if (d.id)  id  = d.id;
        if (d.url) url = d.url;
      }
    }

    /* ---- Native Shopify-hosted video ---- */
    if (type === 'native' && sources) {
      var v = document.createElement('video');
      v.controls = true;
      v.autoplay = true;
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('muted', '');
      v.style.cssText = 'width:100%;height:100%;object-fit:contain;background:#000;display:block;';

      sources.split('|').filter(Boolean).forEach(function (srcUrl) {
        var src = document.createElement('source');
        src.src = srcUrl;
        if (/\.m3u8(\?|#|$)/i.test(srcUrl))      src.type = 'application/x-mpegURL';
        else if (/\.webm(\?|#|$)/i.test(srcUrl)) src.type = 'video/webm';
        else if (/\.ogv?(\?|#|$)/i.test(srcUrl)) src.type = 'video/ogg';
        else                                     src.type = 'video/mp4';
        v.appendChild(src);
      });

      /* Safari sometimes needs an explicit play() call */
      v.addEventListener('loadedmetadata', function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });

      return v;
    }

    /* ---- YouTube / Vimeo embed ---- */
    if (type === 'youtube' || type === 'vimeo') {
      var embed = toEmbedUrl(type, id);
      if (!embed) return null;
      var f = document.createElement('iframe');
      f.src = embed;
      f.setAttribute('frameborder', '0');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen; accelerometer; gyroscope');
      f.setAttribute('allowfullscreen', '');
      f.style.cssText = 'width:100%;height:100%;border:0;display:block;';
      return f;
    }

    /* ---- Direct file URL (mp4/webm/mov) ---- */
    if (type === 'file' && url) {
      var v2 = document.createElement('video');
      v2.controls = true;
      v2.autoplay = true;
      v2.playsInline = true;
      v2.setAttribute('playsinline', '');
      v2.style.cssText = 'width:100%;height:100%;object-fit:contain;background:#000;display:block;';
      var s2 = document.createElement('source');
      s2.src = url;
      v2.appendChild(s2);
      v2.addEventListener('loadedmetadata', function () {
        var p = v2.play();
        if (p && p.catch) p.catch(function () {});
      });
      return v2;
    }

    /* ---- Generic iframe ---- */
    if (type === 'iframe' && url) {
      var f2 = document.createElement('iframe');
      f2.src = url;
      f2.setAttribute('frameborder', '0');
      f2.setAttribute('allowfullscreen', '');
      f2.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
      f2.style.cssText = 'width:100%;height:100%;border:0;display:block;';
      return f2;
    }

    return null;
  }

  function playVideo(scope, thumb) {
    var main = scope.querySelector('.eds-gallery__main');
    if (!main) return;

    /* Ensure the main container can host an absolutely-positioned overlay */
    if (getComputedStyle(main).position === 'static') {
      main.style.position = 'relative';
    }

    /* Remove any existing stage first */
    stopVideo(scope);

    var stage = document.createElement('div');
    stage.className = 'eds-video-stage';
    stage.style.cssText =
      'position:absolute;inset:0;background:#000;z-index:20;' +
      'display:flex;align-items:center;justify-content:center;';

    var player = buildPlayer(thumb);
    if (!player) { return; }
    stage.appendChild(player);

    /* Close button */
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Luk video');
    close.innerHTML = '&times;';
    close.style.cssText =
      'position:absolute;top:10px;right:10px;z-index:21;' +
      'width:36px;height:36px;border:0;border-radius:50%;' +
      'background:rgba(0,0,0,.65);color:#fff;font-size:22px;line-height:1;' +
      'cursor:pointer;display:flex;align-items:center;justify-content:center;';
    close.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      stopVideo(scope);
    });
    stage.appendChild(close);

    main.appendChild(stage);

    /* Visual feedback on the thumb */
    scope.querySelectorAll('.eds-thumb, .eds-thumb--video').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  }

  function stopVideo(scope) {
    var main = scope.querySelector('.eds-gallery__main');
    if (!main) return;
    var stage = main.querySelector('.eds-video-stage');
    if (stage) {
      /* Pause any <video> so audio doesn't keep playing */
      stage.querySelectorAll('video').forEach(function (v) {
        try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
      });
      stage.remove();
    }
  }

  function init(scope) {
    if (scope.__edsVideoInit) return;
    scope.__edsVideoInit = true;

    /* Use capture phase so we intercept before any other gallery handler */
    scope.addEventListener('click', function (e) {
      /* --- Video thumb clicked --- */
      var videoThumb = e.target.closest('[data-eds-play]');
      if (videoThumb && scope.contains(videoThumb)) {
        e.preventDefault();
        e.stopPropagation();
        playVideo(scope, videoThumb);
        return;
      }

      /* --- Regular image thumb clicked → close any open video --- */
      var imgThumb = e.target.closest('.eds-thumb[data-eds-thumb]');
      if (imgThumb && scope.contains(imgThumb)) {
        stopVideo(scope);
        return;
      }

      /* --- Dot clicked → close any open video --- */
      var dot = e.target.closest('.eds-gallery__dot');
      if (dot && scope.contains(dot)) {
        stopVideo(scope);
        return;
      }

      /* --- Arrow clicked → close any open video --- */
      var arrow = e.target.closest('.eds-gallery__arrow');
      if (arrow && scope.contains(arrow)) {
        stopVideo(scope);
        return;
      }
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-eds-configurator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor: re-init after section reload */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target.querySelector('[data-eds-configurator]');
    if (scope) {
      scope.__edsVideoInit = false;
      init(scope);
    }
  });
})();